export default "__VITE_ASSET__CQbpVwEJ__"